/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import cx from 'classnames';
import { Label } from '@/features/i18n';
import { formatPrice } from '@/utils/validator/formatPrice';
import azCommonStyles from '@/theme/globals.module.scss';
import styles from '@/components/Cart/CommonCounterPart/PreOrderQuantitySelector/styles.module.scss';

type EachItemPriceProps = {
  count: number;
  unitPrice: number | null;
  isBopusMexicoStoreEnabled: boolean;
};

export const EachItemPrice = ({
  count,
  unitPrice,
  isBopusMexicoStoreEnabled,
}: EachItemPriceProps) => {
  if (count <= 1 || !unitPrice) {
    return null;
  }

  const eachLabel = isBopusMexicoStoreEnabled ? (
    <Label label="label_cart_Each" />
  ) : (
    <Label label="label_cart_lineItem_Each" />
  );

  return (
    <div
      className={cx(
        azCommonStyles['az-body-3-regular'],
        azCommonStyles['az-margin-top-4xs'],
        azCommonStyles['az-align-center'],
        styles.unitPrice,
      )}
    >
      {eachLabel} ${formatPrice(unitPrice)}
    </div>
  );
};
